import { Formik, Form, Field, FieldArray } from 'formik'
import { bankSchema } from '../../validation/bank.schema';
import { Grid, FormHelperText, IconButton, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

function BankForm({ initialValues, onSubmit, submitLabel }) {
   return (
      <Formik
         initialValues={{
            bank_name: initialValues?.bank_name || '',
            account_no: initialValues?.account_no || '',
            account_type: initialValues?.account_type || '',
            other_fields: initialValues?.other_fields || [],
         }}
         validationSchema={bankSchema}
         onSubmit={onSubmit}
         enableReinitialize
         validateOnMount
      >
         {({ values, isSubmitting, errors, touched }) => (
            <Form noValidate>
               <Grid container spacing={3}>
                  <Grid item md={4} xs={12}>
                     <div className="form-group">
                        <label htmlFor="bank_name">
                           Bank Name <span className="text-danger">*</span>
                        </label>
                        <Field
                           id="bank_name"
                           name="bank_name"
                           className="form-control"
                           placeholder="Enter bank name"
                           disabled={isSubmitting}
                        />
                        {touched.bank_name && errors.bank_name && (
                           <FormHelperText sx={{ color: '#d32f2f', margin: '3px 14px' }}>
                              {errors.bank_name}
                           </FormHelperText>
                        )}
                     </div>
                  </Grid>

                  <Grid item md={4} xs={12}>
                     <div className="form-group">
                        <label htmlFor="account_no">
                           Account Number <span className="text-danger">*</span>
                        </label>
                        <Field
                           id="account_no"
                           name="account_no"
                           className="form-control"
                           placeholder="Enter account number"
                           disabled={isSubmitting}
                        />
                        {touched.account_no && errors.account_no && (
                           <FormHelperText sx={{ color: '#d32f2f', margin: '3px 14px' }}>
                              {errors.account_no}
                           </FormHelperText>
                        )}
                     </div>
                  </Grid>

                  <Grid item md={4} xs={12}>
                     <div className="form-group">
                        <label htmlFor="account_type">
                           Account Type
                        </label>
                        <Field
                           id="account_type"
                           name="account_type"
                           className="form-control"
                           placeholder="example: USD Account or GBP Account"
                           disabled={isSubmitting}
                        />
                        {touched.account_type && errors.account_type && (
                           <FormHelperText sx={{ color: '#d32f2f', margin: '3px 14px' }}>
                              {errors.account_type}
                           </FormHelperText>
                        )}
                     </div>
                  </Grid>
               </Grid>

               <div className="mt-4 mb-2">
                  <h5 style={{ fontSize: '1.1rem', fontWeight: 600 }}>Other Fields (Custom Key-Value Details)</h5>
                  <p className="text-muted" style={{ fontSize: '0.85rem' }}>
                     Add additional details such as IFSC Code, Swift Code, Branch, Account Type, etc.
                  </p>
               </div>

               <FieldArray name="other_fields">
                  {({ push, remove }) => (
                     <div>
                        {values.other_fields && values.other_fields.length > 0 ? (
                           values.other_fields.map((field, index) => (
                              <Grid container spacing={2} key={index} alignItems="center" className="mb-2">
                                 <Grid item md={5} xs={5}>
                                    <div className="form-group mb-0">
                                       <label htmlFor={`other_fields.${index}.label`} style={{ fontSize: '0.85rem' }}>
                                          Label
                                       </label>
                                       <Field
                                          name={`other_fields.${index}.label`}
                                          className="form-control"
                                          placeholder="e.g. IFSC Code"
                                          disabled={isSubmitting}
                                       />
                                       {touched.other_fields?.[index]?.label &&
                                          errors.other_fields?.[index]?.label && (
                                             <FormHelperText sx={{ color: '#d32f2f', margin: '2px 0' }}>
                                                {errors.other_fields[index].label}
                                             </FormHelperText>
                                          )}
                                    </div>
                                 </Grid>
                                 <Grid item md={6} xs={5}>
                                    <div className="form-group mb-0">
                                       <label htmlFor={`other_fields.${index}.value`} style={{ fontSize: '0.85rem' }}>
                                          Value
                                       </label>
                                       <Field
                                          name={`other_fields.${index}.value`}
                                          className="form-control"
                                          placeholder="e.g. UTIB0000021"
                                          disabled={isSubmitting}
                                       />
                                       {touched.other_fields?.[index]?.value &&
                                          errors.other_fields?.[index]?.value && (
                                             <FormHelperText sx={{ color: '#d32f2f', margin: '2px 0' }}>
                                                {errors.other_fields[index].value}
                                             </FormHelperText>
                                          )}
                                    </div>
                                 </Grid>
                                 <Grid item md={1} xs={2} className="d-flex align-items-end pt-4">
                                    <IconButton
                                       color="error"
                                       onClick={() => remove(index)}
                                       disabled={isSubmitting}
                                       title="Remove field"
                                    >
                                       <DeleteIcon />
                                    </IconButton>
                                 </Grid>
                              </Grid>
                           ))
                        ) : (
                           <div className="text-muted mb-2" style={{ fontSize: '0.875rem' }}>
                              No dynamic fields added yet. Click &quot;Add Field&quot; below to add custom fields.
                           </div>
                        )}

                        <div className="mb-3 mt-2">
                           <Button
                              type="button"
                              variant="outlined"
                              startIcon={<AddIcon />}
                              onClick={() => push({ label: '', value: '' })}
                              disabled={isSubmitting}
                              size="small"
                           >
                              Add Field
                           </Button>
                        </div>
                     </div>
                  )}
               </FieldArray>

               <div className="mt-4">
                  <button type="submit" className="btn commonBtn" disabled={isSubmitting}>
                     {isSubmitting ? (
                        <>
                           <span
                              className="spinner-border spinner-border-sm mr-2"
                              role="status"
                              aria-hidden="true"
                           />
                           Submitting...
                        </>
                     ) : (
                        submitLabel
                     )}
                  </button>
               </div>
            </Form>
         )}
      </Formik>
   );
}

export default BankForm;